$(function() {
  renderMarkdown($('#product_resources_lp_desc_product_specific'), $.polyglot.t('product_resources_lp_desc_product_specific', $.interpolations));

  $('#product-resources-selected-reg').on('change', function() {
    var selected_id = $(this).val();
    var product_id = $('#product-resources-tiles-display').data('product-id');
    if(selected_id != product_id) {
      window.location.href = "/product_resources/?pid="+selected_id;
    }
  });

  $("#selected-model-btn").on('click', function() {
    var product_id = $("#product").val();
    if(product_id) {
      window.location.href = "/product_resources/?pid="+product_id;
    }
  });

  $("#unknown-model-btn").on('click', function() {
    window.location.href = "/product_resources";
  });
});

$(document).ready(function() {
  renderMarkdown($('#footer-text'), $.polyglot.t('footer_text', $.interpolations));
  if ( _.get($.siteConfiguration,"enable_footer_links" ) ){
    renderMarkdown($('#footer_links'), $.polyglot.t('footer_links', $.interpolations));
  }
});

$(document).ready(function() {
  if (!localStorage.bannerClosed) { 
    const isHomeOrReg = window.location.pathname === "/" || window.location.pathname === "/reg" || window.location.pathname.indexOf("/reg/") !== -1  ;
    const isLocaleHomeOrReg = window.location.pathname === "/" + $.currentLocale || window.location.pathname === "/" + $.currentLocale + "/reg" || window.location.pathname == "/"+ $.currentLocale +"/";

    if (isHomeOrReg || isLocaleHomeOrReg) {
      $('.cookieinfo-banner').css('display', 'inherit');
    }
    else {
      $('.cookieinfo-banner').css('display', 'none');
    } 
  } else {
      $('.cookieinfo-banner').css('display', 'none');
  }

  $('.cookieinfo-accept').on('click', function() {
    $('.cookieinfo-banner').css('display', 'none');
    $('#cookie_policy_accepted').val(1);
    localStorage.bannerClosed = 'true'
  });
});